export default __webpack_public_path__ + "static/accordion_small-de84f702029de0487bc7e4794e4ad1be.png";